import {
  Button,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { moneyMaskNumber } from "utils/mask/money";
import { IPaymentLinkResponse } from "models/paymentLink/IPaymentLinkResponse";
import React, { FC, useMemo, useRef } from "react";
import CreditForm from "../creditForm/CreditForm";
import styles from "./Credit.module.scss";
import { UseCredit } from "./UseCredit";
import { useUi } from "context/ui/UIContext";
import { ReactComponent as Check } from "assets/icons/check.svg";
import { ReactComponent as Load } from "assets/icons/loading.svg";
import { ArrowDropDown, Info } from "@material-ui/icons";

export interface ICredit {
  paymentLink: IPaymentLinkResponse;
}

const Credit: FC<ICredit> = ({ paymentLink }) => {
  const {
    card,
    setCard,
    onClickSend,
    installment,
    setInstallment,
    approved,
    loading,
    errors,
    address,
    setAddress,
    owner,
    setOwner,
    cardBrand,
  } = UseCredit(paymentLink);

  const { isMobile } = useUi();

  const formRef = useRef<HTMLDivElement>(null);

  const renderOneInstallment = useMemo(() => {
    setInstallment(
      paymentLink.cardBrandsInstallments.find((x) => x.brandType === cardBrand)
        ?.installments[0]
    );
    return (
      <TextField
        className={styles.installmentContainer}
        required
        variant="outlined"
        fullWidth
        value={`${
          paymentLink.cardBrandsInstallments.find(
            (x) => x.brandType === cardBrand
          )?.installments[0]?.description
        } - Total ${moneyMaskNumber(
          paymentLink.cardBrandsInstallments.find(
            (x) => x.brandType === cardBrand
          )?.installments[0]?.price ?? 0
        )}`}
        label="Número de parcelas"
        disabled
      />
    );
  }, [cardBrand, paymentLink.cardBrandsInstallments, setInstallment]);

  if (approved.length) {
    return (
      <div className={styles.approved}>
        <Check />
        <p>
          {paymentLink.successMessage
            ? paymentLink.successMessage
            : "Transação aprovada!"}
        </p>
        <p>
          Valor pago: <b> {moneyMaskNumber(Number(paymentLink.price))}</b>
        </p>
        <p>
          Pedido: <b> {approved}</b>
        </p>

        {/* 
          PODER DO NETWORK BRASILIA - VENDA ONLINE 
        */}
        {paymentLink.id.toUpperCase() ===
          "C81FFB14-85F6-4093-A303-F9EFD8D17D85" && (
          <div className={styles.whatsAppContact}>
            <svg
              width="160"
              height="104"
              viewBox="0 0 89 88"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.767559 87.75L6.68256 66.015C2.78504 59.3337 0.737353 51.735 0.750059 44C0.750059 19.8369 20.3369 0.25 44.5001 0.25C68.6632 0.25 88.2501 19.8369 88.2501 44C88.2501 68.1631 68.6632 87.75 44.5001 87.75C36.7685 87.7625 29.1729 85.7164 22.4938 81.8219L0.767559 87.75ZM28.7107 23.4725C28.1457 23.5076 27.5936 23.6564 27.0876 23.91C26.613 24.1788 26.1797 24.5147 25.8013 24.9075C25.2763 25.4019 24.9788 25.8306 24.6594 26.2462C23.0425 28.3506 22.1727 30.9337 22.1876 33.5875C22.1963 35.7312 22.7563 37.8181 23.6313 39.7694C25.4207 43.7156 28.3651 47.8937 32.2544 51.7656C33.1907 52.6975 34.1051 53.6338 35.0894 54.5044C39.9168 58.7545 45.6693 61.8195 51.8894 63.4556L54.3788 63.8363C55.1882 63.88 55.9976 63.8187 56.8113 63.7794C58.0855 63.7136 59.3296 63.3686 60.4557 62.7688C61.1819 62.3838 61.5232 62.1912 62.1313 61.8062C62.1313 61.8062 62.3194 61.6837 62.6782 61.4125C63.2688 60.975 63.6319 60.6644 64.1219 60.1525C64.4851 59.7763 64.8001 59.3344 65.0407 58.8313C65.3819 58.1181 65.7232 56.7575 65.8632 55.6244C65.9682 54.7581 65.9376 54.2856 65.9244 53.9925C65.9069 53.5244 65.5176 53.0388 65.0932 52.8331L62.5469 51.6913C62.5469 51.6913 58.7407 50.0331 56.4176 48.9744C56.1726 48.8676 55.9101 48.8068 55.6432 48.795C55.3438 48.7643 55.0414 48.7979 54.7562 48.8938C54.4709 48.9896 54.2095 49.1454 53.9894 49.3506V49.3419C53.9676 49.3419 53.6744 49.5913 50.5113 53.4238C50.3298 53.6677 50.0797 53.8521 49.7929 53.9534C49.5062 54.0547 49.1958 54.0683 48.9013 53.9925C48.6162 53.9163 48.337 53.8198 48.0657 53.7038C47.5232 53.4763 47.3351 53.3888 46.9632 53.2269L46.9413 53.2181C44.4384 52.1254 42.121 50.6493 40.0726 48.8431C39.5213 48.3619 39.0094 47.8369 38.4844 47.3294C36.7632 45.681 35.2632 43.8163 34.0219 41.7819L33.7638 41.3662C33.5784 41.087 33.4285 40.7857 33.3176 40.4694C33.1513 39.8262 33.5844 39.31 33.5844 39.31C33.5844 39.31 34.6476 38.1462 35.1419 37.5162C35.5536 36.9927 35.9376 36.448 36.2926 35.8844C36.8088 35.0531 36.9707 34.2 36.6994 33.5394C35.4744 30.5469 34.2057 27.5675 32.9019 24.61C32.6438 24.0237 31.8782 23.6037 31.1826 23.5206C30.9463 23.4944 30.7101 23.4681 30.4738 23.4506C29.8863 23.4214 29.2975 23.4273 28.7107 23.4681V23.4725Z"
                fill="#399C54"
              />
            </svg>

            <div>
              <p>
                Clique no link abaixo para entrar no <b>grupo do Whatsapp</b> do{" "}
                <b>Home Experience - Brasília</b>.
              </p>
              <p>Todas as informações estarão no grupo.</p>
              <p>
                <a
                  href="https://chat.whatsapp.com/CaZsKzcKJgD1dkWZX1mFnV"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Clique aqui!
                </a>
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <Container maxWidth="md">
      <div
        id={styles.Credit}
        style={{ marginBottom: isMobile ? 16 : undefined }}
      >
        <div className={styles.title}>
          Realize o pagamento através do Cartão de crédito
        </div>

        {!paymentLink.isSinglePayment && (
          <div className={styles.infoCredit}>
            <Info />
            <div>
              <span>
                A cobrança será realizada todo o dia{" "}
                <b>{paymentLink.paymentDay}</b>.
              </span>
              <span>
                A primeira cobrança será feita no mês{" "}
                <b>
                  {paymentLink.billingStartsInCurrentMonth
                    ? "atual"
                    : "seguinte"}
                </b>
                .
              </span>
            </div>
          </div>
        )}

        <div
          className={styles.container}
          ref={formRef}
          style={{ height: isMobile ? "auto" : undefined }}
        >
          <CreditForm
            card={card}
            setCard={setCard}
            formRef={formRef}
            errors={errors}
            address={address}
            setAddress={setAddress}
            owner={owner}
            setOwner={setOwner}
          />

          {!paymentLink.isRecurrenceLimit ? (
            <Grid
              item
              xs={12}
              style={{ padding: isMobile ? undefined : "0 14px" }}
            >
              {(paymentLink.cardBrandsInstallments.find(
                (x) => x.brandType === cardBrand
              )?.installments.length ?? 0) === 1 ? (
                renderOneInstallment
              ) : (
                <TextField
                  className={styles.installmentContainer}
                  fullWidth
                  variant="outlined"
                  label="Número de parcelas"
                  value={installment?.installment}
                  onChange={(ev) =>
                    setInstallment(
                      paymentLink?.cardBrandsInstallments
                        .find((x) => x.brandType === cardBrand)
                        ?.installments.find(
                          (item) =>
                            item.installment ===
                            Number.parseInt(ev.target.value)
                        )
                    )
                  }
                  select
                >
                  {paymentLink?.cardBrandsInstallments
                    .find((x) => x.brandType === cardBrand)
                    ?.installments.map((installment) => (
                      <MenuItem value={installment.installment}>
                        {installment.description} - Total{" "}
                        {moneyMaskNumber(installment.price)}
                      </MenuItem>
                    ))}
                </TextField>
              )}
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              style={{ padding: isMobile ? undefined : "0 14px" }}
            >
              <TextField
                className={styles.installmentContainer}
                variant="outlined"
                fullWidth
                label={"Número de cobranças"}
                disabled
                InputLabelProps={{
                  shrink: true,
                  style: { color: "#5f5f5f" },
                }}
                value={`${paymentLink.amountOfCharges}x ${paymentLink.price === 0 ? '0,00' : moneyMaskNumber((paymentLink.price / paymentLink.amountOfCharges ))}`}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <ArrowDropDown />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
        </div>
        <Button
          className={!card ? styles.disabled : ""}
          size="large"
          variant="contained"
          color="primary"
          onClick={() => {
            if (!loading) onClickSend();
          }}
        >
          {loading ? <Load /> : "Finalizar pagamento"}
        </Button>
      </div>
    </Container>
  );
};

export default Credit;
